import { StoplossClaimCreate } from "@/types";
import { validateNotFutureDate, validateMinValue, validateRequired } from "../helpers/validationHelpers";

export const validateStoplossClaims = (values: StoplossClaimCreate): Record<string, string> => {
  const errors: Record<string, string> = {};

  // --- Required Top-Level Fields ---
  validateRequired(values.claimant_id_ref, "claimant_id_ref", errors);
  validateRequired(values.stoploss_claim_type, "stoploss_claim_type", errors, "Claim type is required");
  validateRequired(values.claim_status, "claim_status", errors);

  // --- Financial Amount Validations ---
  if (values.total_billed_amount !== undefined) {
    validateMinValue(values.total_billed_amount, "total_billed_amount", errors);
  }

  if (values.total_allowed_amount !== undefined) {
    validateMinValue(values.total_allowed_amount, "total_allowed_amount", errors);
  }

  if (values.estimated_future_expenses !== undefined) {
    validateMinValue(values.estimated_future_expenses, "estimated_future_expenses", errors);
  }

  if (values.total_prior_submissions_ytd !== undefined) {
    validateMinValue(values.total_prior_submissions_ytd, "total_prior_submissions_ytd", errors);
  }

  if (values.total_amount_accel_funded !== undefined) {
    validateMinValue(values.total_amount_accel_funded, "total_amount_accel_funded", errors);
  }

  // --- Date Validations ---
  if (values.submitted_date) {
    validateNotFutureDate(values.submitted_date, "submitted_date", errors, "Submitted date cannot be in the future");
  }

  return errors;
};
